<template>
  <div class="auth-page">
    <div class="background-image">
      <img src="/images/car.jpeg" alt="Car" />
    </div>
    <div class="auth-sidebar" id="auth-sidebar">
      <div class="auth-container">
        <div class="logo text-center">
          <img src="/images/lga-logo.png" alt="LGA Logo" />
        </div>
        <hr />
        <h1>Login</h1>
        <p>
          Welcome to Axis - Please sign in with your account details to
          continue.
        </p>

        <div
          class="alert alert-danger"
          v-if="form.errors.has('email') || form.errors.has('password')"
        >
          <h4>Error!</h4>
          <p>Sorry, the following errors occurred:</p>
          <ul>
            <li
              v-bind:key="index"
              v-for="(error, index) in form.errors.all()"
              v-text="error[0]"
            ></li>
          </ul>
        </div>

        <div class="alert alert-danger" v-if="failedAttempt">
          <h4>Error!</h4>
          <p class="mb-0">Sorry, those login credentials were wrong.</p>
        </div>

        <form>
          <inputbox
            name="email"
            label="Email"
            placeholder="email@example.com"
            type="email"
            v-model="form.username"
            :stacked="false"
            :show-error="form.errors.has('email')"
            :error-message="form.errors.get('email')"
          ></inputbox>

          <inputbox
            name="password"
            label="Password"
            placeholder="Password"
            type="password"
            v-model="form.password"
            :stacked="false"
            :show-error="form.errors.has('password')"
            :error-message="form.errors.get('password')"
            v-on:enter="attempt"
          ></inputbox>

          <div class="row">
            <div class="col-lg-6">
              <form-button :indicator="indicator" v-on:clicked="attempt"
                >Sign In
              </form-button>
            </div>
            <div class="col-lg-6">
              <router-link
                to="/forgot-password"
                class="text-right small forgot-password"
                >I've forgotten my password
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from '../../auth';

export default {
  data() {
    return {
      form: new window.Form({
        username: null,
        password: null
      }),
      failedAttempt: false,
      indicator: false
    };
  },

  mounted() {
    new window.Ps(document.getElementById('auth-sidebar'));
  },

  methods: {
    attempt() {
      this.indicator = true;

      let auth = new Auth();

      this.form
        .post('/authenticate/token')
        .then(response => {
          this.failedAttempt = false;
          this.indicator = false;

          window.Token.set(response.access_token);

          auth
            .getUser()
            .then(data => {
              if (!data.identifier) {
                this.$router.push('/login');
              }
              this.$store.commit('setUser', data);
            })
            .catch(error => {
              window.Token.forget();
              this.route('/login');
            });

          this.getRecords();
          this.route('/dashboard');
        })
        .catch(error => {
          this.indicator = false;
          if (error.error === 'Invalid credentials') {
            this.failedAttempt = true;
          }
        });
    },

    getRecords() {
      this.$store.commit('Titles/retrieve');
      this.$store.commit('Roles/retrieve');
      this.$store.commit('SecurityQuestions/retrieve');
      this.$store.commit('ContactMethods/retrieve');
      this.$store.commit('ContactTimes/retrieve');
      this.$store.commit('VehicleGroups/retrieve');
      this.$store.commit('Genders/retrieve');
      this.$store.commit('VehicleMakes/retrieve');
      this.$store.commit('VehicleTransmissions/retrieve');
      this.$store.commit('VehicleTypes/retrieve');
      this.$store.commit('LicenceAuthorities/retrieve');
      this.$store.commit('Insurers/retrieve');
      this.$store.commit('CoverLevels/retrieve');
      this.$store.commit('VehicleUseTypes/retrieve');
      this.$store.commit('IncidentClaimTypes/retrieve');
      this.$store.commit('Companies/retrieve');
      this.$store.commit('IncidentStatus/retrieve');
    }
  }
};
</script>
